export enum EUpdateProvider {
	appaloosa = "appaloosa",
	calaoStore = "calaostore"
}
